import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Hint } from './Hint';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { Help } from '../../Form2/partials/Help/Help';

export function DynamicallyGeneratedContentHint({ customHelpText }: { customHelpText?: string }) {
  const { t } = useSonTranslation('phrases');
  const id = useHtmlValidId();

  return (
    <div className="hint__container">
      <Hint message={t('dynamicallyGeneratedBlockContent.text')} />
      <Help id={id} helpText={customHelpText ?? t('dynamicallyGeneratedBlockContent.explanation')} />
    </div>
  );
}
